module.exports = __webpack_public_path__ + "img/levante-black.b6d3c02d.png";